import PropTypes from 'prop-types';
import React from 'react';
import {ListItemButton, ListItemText} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {SOURCE_TYPES} from '@explorer/util/search';

const SearchInputOption = ({option, ...props}) => {
  const {t} = useTranslation();
  let primary = option.description;
  let secondary;
  if (option.source === SOURCE_TYPES.LATLON) {
    primary = t('searchInput.latLonDescription', option.context);
  } else if (
    option.source === SOURCE_TYPES.MGRS_POINT ||
    option.source === SOURCE_TYPES.MGRS_SQUARE
  ) {
    primary = t(`searchInput.${option.source}`, {
      query: option.query,
    });
  } else if (option.source === SOURCE_TYPES.ITEM_IDS) {
    [primary, secondary] = option.description.split(' ');
  }

  if (option.search) {
    secondary = t('searchInput.savedSearchLabel');
  } else if (option.descriptionDetails?.length) {
    secondary = option.descriptionDetails.join(t('global.listJoin'));
  }

  return (
    <ListItemButton {...props}>
      <ListItemText
        primary={primary}
        secondary={secondary}
        primaryTypographyProps={{noWrap: true}}
        data-qe="search-suggestion"
      />
    </ListItemButton>
  );
};

SearchInputOption.propTypes = {
  option: PropTypes.shape({
    description: PropTypes.string,
    descriptionDetails: PropTypes.array,
    search: PropTypes.bool,
    source: PropTypes.string,
    context: PropTypes.object,
    query: PropTypes.string,
  }),
};

export default SearchInputOption;
